<template>
  <div>
    <div class="hero" v-if="!loading && plan.published !== true">
      <div class="hero-body">
        <h1 class="admin-title"><b>{{ $t('dashboard.standby') }}</b></h1>
        <h3>Es ist noch kein Vertretungsplan verfügbar.</h3>
      </div>
    </div>
    <div class="hero" v-else-if="!loading && plan.subs.length === 0">
      <div class="hero-body">
        <h1 class="admin-title"><b>{{ $t('dashboard.standby') }} {{plan.filter}}</b></h1>
        <h3>Es liegen aktuell keine Vertretungen für deine Klasse
          vor. In der Regel ist der Plan um 19.00 fertig. Dieser kann sich im Laufe des
          Abends noch ändern. Ausschlaggebend ist der Plan am Morgen eines jeden Tages.
        </h3>
      </div>
    </div>
    <section v-else-if="!loading" class="hero">
      <div class="hero-body">
        <h1 class="admin-title"><b>{{ $t('dashboard.standby')}}</b> für die
          <b>{{plan.filter}}</b> am <b>{{plan.daydate}}</b></h1>
        <b-table
          sort-by="hour"
          class="mt-1 app-table"
          v-if="!loading"
          :data="plan.subs"
          :bordered="false"
          :striped="false"
          :narrowed="false"
          :hoverable="true"
          :loading="false"
          :focusable="false"
          :mobile-cards="true"
          :paginated="false">
          <b-table-column field="hour" label="Stunde" sortable v-slot="props">
            {{ props.row.hour }}
          </b-table-column>

          <b-table-column field="subject" label="Fach" sortable v-slot="props">
            {{ props.row.subject }}
          </b-table-column>

          <b-table-column field="missing" label="Fehlende(r)" sortable v-slot="props">
            {{ props.row.missing.lastname }}
          </b-table-column>

          <b-table-column field="substitute" label="Vertretung" sortable v-slot="props">
            <p v-if="!(props.row.substitute.lastname === 'Nur Bemerkung' && !props.row.comment)">
              {{ props.row.substitute.lastname === 'Nur Bemerkung'
                ? props.row.comment
                : props.row.comment
                  ? props.row.substitute.lastname + ', ' + props.row.comment
                  : props.row.substitute.lastname }}
            </p>
          </b-table-column>
        </b-table>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable dot-notation */
/* eslint-disable max-len */

import moment from 'moment';
import formatting from '../mixins/formatting';

export default {
  components: {
  },
  mixins: [formatting],
  data() {
    return {
      plan_for_date: new Date(),
      table_selected: {},
      edit: false,
      edit_modal: false,
      plan_modal: false,
      entry: {},
      hotloading: false,
      name: '',
      name_sub: '',
    };
  },

  created() {
    this.$store.dispatch('Account/load');
    this.plan_for_date.setDate(this.plan_for_date.getDate() + 1);
    this.get_plan_student();
  },

  computed: {
    plan_class() {
      if (this.latest_plan.subs) {
        const plan = this.latest_plan.subs.filter((row) => String(row.class).toLowerCase().trim().includes(this.current_class.toLowerCase().trim()));
        return plan;
      }
      return [];
    },
    plan() {
      return this.$store.getters['Plans/get_latest_plan'];
    },
    user() {
      return this.$store.getters['User/user'];
    },
    current_class() {
      return this.$store.getters['User/user'].class;
    },
    current_weekday() {
      return this.$store.getters['Plans/get_weekday_from_plan'];
    },
    client() {
      return this.$store.getters['Clients/login_client'];
    },
    loading() {
      return this.$store.getters['Plans/loading'];
    },
    latest_plan() {
      return this.$store.getters['Plans/get_latest_plan'];
    },
    available_teachers() {
      return this.$store.getters['Teachers/get_available_teachers'];
    },
    get_completete_search_list() {
      return this.$store.getters['Teachers/get_completete_search_list'];
    },
    search_teachers() {
      if (this.$store.getters['Teachers/get_search_list'].length === 0) {
        return this.teachers;
      }
      return this.$store.getters['Teachers/get_search_list'];
    },
    is_old() {
      if (moment(this.plan_for_date) < moment().subtract('days', 1)) return true;
      return false;
    },
  },

  methods: {
    color(row) {
      if (row.substitute.lastname === 'offen') {
        return 'alert';
      }
      return '';
    },
    substchange(event) {
      this.$store.commit('Plans/mutate_remove_double', event);
    },
    make_plan() {
      this.$store.dispatch('Plans/make_plan').then(() => {
        this.$buefy.toast.open({
          message: 'Plan aktualisiert.',
          type: 'is-success',
        });
      });
    },
    close_plan_modal() {
      this.plan_modal = false;
    },
    show_reg_plan() {
      this.plan_modal = true;
    },
    go_next() {
      this.plan_for_date = moment(this.plan_for_date).add(1, 'days')['_d'];
      this.get_plan();
    },
    go_back() {
      this.plan_for_date = moment(this.plan_for_date).subtract(1, 'days')['_d'];
      this.get_plan();
    },
    get_plan_student() {
      this.$store.dispatch('Plans/get_plan_student', this.plan_for_date);
    },
    get_plan() {
      this.$store.dispatch('Plans/get_plan_student', this.plan_for_date);
    },
    save_plan() {
      this.$store.dispatch('Plans/save_plan').then((response) => {
        if (response) {
          this.$buefy.toast.open({
            message: 'Vertretungsplan wurde gespeichert',
            type: 'is-success',
          });
          this.edit = false;
          this.get_plan();
        } else {
          this.$buefy.toast.open({
            message: 'Vertretungsplan konnte nicht gespeichert werden.',
            type: 'is-danger',
          });
        }
      });
    },
    send_plan() {
      this.$store.dispatch('Plans/send_plan', this.plan_for_date).then((response) => {
        if (response) {
          this.$buefy.toast.open({
            message: 'Vertretungsplan wurde versendet',
            type: 'is-success',
          });
          this.edit = false;
        } else {
          this.$buefy.toast.open({
            message: 'Vertretungsplan konnte nicht versendet werden.',
            type: 'is-danger',
          });
        }
      });
    },
    add_sub() {
      this.edit_modal = true;
    },
    save_sub() {
      this.entry.type = 'm';
      this.$store.commit('Plans/save_sub', this.entry).then((response) => {
        console.log(response);
      });
    },
    reset_selected() {
      this.edit_modal = false;
    },
    search() {
      if (this.name === '') return;
      this.$store.dispatch('Teachers/search_teacher', this.name);
    },
    search_sub() {
      if (this.name === '') return;
      this.$store.dispatch('Teachers/search_teacher', this.name_sub);
    },
    select_missing(teacher) {
      this.entry.missing = teacher;
    },
    select_sub(teacher) {
      this.entry.substitute = teacher;
    },
  },
};
</script>

<style lang="scss" local>

.dashboard {
  background-color: white;
  .table {
    tr.is-selected {
      background-color: var(--secondary-color)!important;
    }
    .tc{
      padding: 0pt;
    }
    tr {
      cursor: pointer;
    }
    .dropdown {
      width: 100% !important;
    }
  }
}
.textarea {
  min-height: 4rem !important;
}
.date-button {
  background-color: var(--secondary-color) !important;
  color: white !important;
  border-radius: 0 !important;
  width: 3.5rem;
  border: none;
  border-radius: 6px !important;
  cursor: pointer;
}
.alert {
  background-color: rgb(255, 94, 94) !important;
}
.inline {
  display: inline;
}
</style>
